/**************************************************************************************************/
/** @import Constants                                                                            **/
/**************************************************************************************************/
import { AppValues } from '@/Constants/AppValues'

/**************************************************************************************************/
/** @export Class @name ItemMissingFields                                                        **/
/**************************************************************************************************/
export class ItemMissingFields
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	private fields: { [key: string]: { text: string } }

	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor()
	{
		this.fields = {}
	}

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public add(field: string, text: (string | { $text: string }) = AppValues.Strings.DEFAULT_EMPTY_STRING) : ItemMissingFields
	{
		this.fields[field] = typeof text === 'string' ? { text } : { text: text.$text }
		return this
	}

	public getField(key: string) : { text: string }
	{
		return this.fields[key]
	}

	public getFields() : { [key: string]: { text: string } }
	{
		return this.fields
	}
}